import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import useFetchPreferredCurrency from '../multicurrency/hooks/useFetchPreferredCurrency';
import { DISMISS_EXCHANGE_RATE_ALERT } from '../../actions/ActionTypes';
import { getDismissedExchangeRateAlert } from '../../selectors/alertsSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const ExchangeRateAlert = () => {
  const dispatch = useDispatch();
  const dismissExchangeRateAlert = useSelector(getDismissedExchangeRateAlert);
  const {
    userHasDifferentPreferredCurrency
  } = useFetchPreferredCurrency();
  const showAlert = userHasDifferentPreferredCurrency && !dismissExchangeRateAlert;
  const handleClose = useCallback(() => {
    dispatch({
      type: DISMISS_EXCHANGE_RATE_ALERT
    });
  }, [dispatch]);
  if (!showAlert) {
    return null;
  }
  return /*#__PURE__*/_jsx(Alert, {
    closeable: true,
    use: "inline",
    marginBlockEnd: "400",
    onClose: handleClose,
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "alerts.exchangeRate.titleText"
    }),
    type: "info",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "alerts.exchangeRate.text"
    })
  });
};
export default ExchangeRateAlert;